import {
  getCtaGroupAlignmentClassName,
  type CtaAlignment,
} from "@/utils/ctaAlignment";

export function CTAGroup({
  children,
  align = "center",
}: Readonly<{ children: React.ReactNode; align?: CtaAlignment }>) {
  return (
    <div
      className={`not-prose my-8 flex flex-col gap-4 sm:flex-row ${getCtaGroupAlignmentClassName(align)} [&>div]:my-0`}
    >
      {children}
    </div>
  );
}
